import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import { useNavigate, Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { useState, useEffect } from 'react';
import moment from 'moment';

import {
  Card,
  Table,
  Stack,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  Container,
  Typography,
  TableContainer,
  Button,
  TableHead,
  TablePagination,
} from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';

import { ActionListToolbar } from '../sections/@dashboard/user';

import USERLIST from '../_mock/rule';
import { getAclMenu, getToken } from '../utils/common';

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el, _i) => el[0]);
}

// Helper functions moved to outer scope for better performance
function handleClickLang(lang) {
  i18next.changeLanguage(lang);
}

export default function UserPage() {
  const [open, setOpen] = useState(null);
  const [acl] = useState(getAclMenu('action'));
  const [page, setPage] = useState(0);

  const [selected] = useState([]);

  const [filterName, setFilterName] = useState('');
  const [data, setData] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleCloseMenu = () => {
    setOpen(null);
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const navigate = useNavigate();

  const handleClicks1 = () => {
    navigate('/dashboard/viewrule', { replace: true });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);

    fetchInfo(`${globalThis.REACT_APP_API_PURE}action/list?limit=${rowsPerPage}&page=${newPage}`);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(Number.parseInt(event.target.value, 10));
    fetchInfo(`${globalThis.REACT_APP_API_PURE}action/list?limit=${Number.parseInt(event.target.value, 10)}&page=0`);
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
    fetchInfo(`${globalThis.REACT_APP_API_PURE}action/list?action_name=${event.target.value}`);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;

  const fetchInfo = (url) =>
    fetch(url, {
      headers: {
        Authorization: `Bearer ${getToken()}`,
      },
    })
      .then((res) => res.json())
      .then((d) => setData(d));
  useEffect(() => {
    fetchInfo(`${globalThis.REACT_APP_API_PURE}action/list`);
  }, []);

  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title> Action Management | COVAS </title>
      </Helmet>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography component="h1" variant="h4" gutterBottom>
            {t('Actions.1')}
          </Typography>
          {!acl?.create ? (
            ''
          ) : (
            <Link to="/dashboard/action/add">
              <Button
                style={{ backgroundColor: 'rgb(79, 138, 226)' }}
                variant="contained"
                startIcon={<Iconify icon="eva:plus-fill" />}
              >
                {t('NewActions.1')}
              </Button>
            </Link>
          )}
        </Stack>

        <Card>
          <ActionListToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} />
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800, borderRadius: 2, border: '1px solid #e0e0e0' }}>
              <Table>
                <TableHead>
                  <TableRow className="custom-table-row">
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('Nomor.1')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('NameActions.1')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('Deskripsyong.1')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('DateTime.1')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('Author.1')}
                    </StyledTableCell>
                    <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                      {t('Actions.2')}
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data?.data?.map((index, row, dataObj) => {
                    const dateString = moment.unix(index.created_at).format('YYYY-MM-DD HH:mm');

                    return (
                      <TableRow hover key={index.id}>
                        <TableCell component="th" scope="row" alignItems="center">
                          {row + 1}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          padding="none"
                          style={{ maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                        >
                          {index.action_name}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          padding="none"
                          style={{ maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                        >
                          {index.description}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {dateString}
                        </TableCell>
                        <TableCell component="th" scope="row" padding="none">
                          {index.created_by}
                        </TableCell>
                        <TableCell>
                          <Link
                            to={{
                              pathname: `/dashboard/action/edit`,
                            }}
                            state={{ index }}
                            style={{
                              textDecoration: 'none',
                              borderRadius: '20px',
                              border: '1px solid #12A2CE',
                              padding: '6px 16px',
                              color: '#12A2CE',
                              display: 'inline-block',
                              textAlign: 'center',
                              cursor: 'pointer',
                            }}
                          >
                            {t('Edit.1')}
                          </Link>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={{ height: 53 * emptyRows }}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={data?.total || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: {
            sx: {
              p: 1,
              width: 140,
              '& .MuiMenuItem-root': {
                px: 1,
                typography: 'body2',
                borderRadius: 0.75,
              },
            },
          },
        }}
      >
        <MenuItem onClick={handleClicks1}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Process
        </MenuItem>
      </Popover>
    </>
  );
}
